// extracted by mini-css-extract-plugin
export var actionIcon = "_redotech-redo-web-lib-arbiter-components-input-redo-search-text-input-action-icon";